var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHealthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "size=32px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.9998 29.3334C23.3636 29.3334 29.3332 23.3638 29.3332 16C29.3332 8.63622 23.3636 2.66669 15.9998 2.66669C8.63604 2.66669 2.6665 8.63622 2.6665 16C2.6665 23.3638 8.63604 29.3334 15.9998 29.3334Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.6668 14.5186C22.6668 14.3221 22.5888 14.1337 22.4499 13.9948C22.311 13.8559 22.1225 13.7778 21.9261 13.7778H18.2224V10.0741C18.2224 9.87766 18.1443 9.68925 18.0054 9.55033C17.8665 9.41142 17.6781 9.33337 17.4816 9.33337H14.5187C14.3222 9.33337 14.1338 9.41142 13.9949 9.55033C13.856 9.68925 13.7779 9.87766 13.7779 10.0741V13.7778H10.0742C9.87778 13.7778 9.68937 13.8559 9.55045 13.9948C9.41154 14.1337 9.3335 14.3221 9.3335 14.5186V17.4815C9.3335 17.678 9.41154 17.8664 9.55045 18.0053C9.68937 18.1442 9.87778 18.2223 10.0742 18.2223H13.7779V21.926C13.7779 22.1224 13.856 22.3108 13.9949 22.4497C14.1338 22.5887 14.3222 22.6667 14.5187 22.6667H17.4816C17.6781 22.6667 17.8665 22.5887 18.0054 22.4497C18.1443 22.3108 18.2224 22.1224 18.2224 21.926V18.2223H21.9261C22.1225 18.2223 22.311 18.1442 22.4499 18.0053C22.5888 17.8664 22.6668 17.678 22.6668 17.4815V14.5186Z",
    stroke: "#1E1E20",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthIcon);
export default __webpack_public_path__ + "static/media/healthIcon.4a5504935eb893997f43c64dda9d60a8.svg";
export { ForwardRef as ReactComponent };